<template>
    <master-dashboard
        master-image="/images/webinars/webinar-image.svg"
        :breadcrumb="{ backLink: `/webinar/${this.$route.params.id}/detail`, prevPage: this.trans('global.back'), currentPage: this.trans('global.module')}"
        :webinar-id="$route.params.id"
    />
</template>

<script>
    import MasterDashboard from "./MasterDashboard";

    export default {
        name: "AugmentedMaster",
        components: {MasterDashboard},
        mounted() {
            trackEvent(`GoToAugmentedMaster`, {
                webinarId: this.$route.params.id
            });
        },
    }
</script>
